import { useEffect, useState } from 'react';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Live view of the signed-in user's Wantlist — one onSnapshot per mounted
 * page, shared by every heart badge on it (WANT_DEMAND_BADGE_PLAN.md).
 *
 * A listener rather than a one-shot read so a tap on one card's heart flips
 * every other card showing the same pedal in the same beat, and so a want
 * added on the detail page is reflected when the user swipes back to Browse.
 *
 * Returns { wants, loading }. Signed out → empty list, not loading.
 */
export function useMyWants(currentUser) {
  const [wants, setWants] = useState([]);
  const [loading, setLoading] = useState(Boolean(currentUser));

  const uid = currentUser?.uid || null;

  useEffect(() => {
    if (!uid) {
      setWants([]);
      setLoading(false);
      return undefined;
    }
    setLoading(true);
    const unsubscribe = onSnapshot(
      query(collection(db, 'wantList'), where('uid', '==', uid)),
      (snap) => {
        setWants(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
        setLoading(false);
      },
      (err) => {
        // Fail closed to "no wants": hearts render unfilled and a tap still
        // works (the add path doesn't depend on this listener).
        console.error('❌ useMyWants listener failed:', err);
        setWants([]);
        setLoading(false);
      }
    );
    return unsubscribe;
  }, [uid]);

  return { wants, loading };
}
